import brandConfig from "@/config/brand.config.json";

export type ProductType = "arc" | "riot";

export interface BrandConfig {
	name: string;
	logo: string;
	primaryColor: string;
	hoverColor: string;
	textColor: string;
}

export const getBrandConfig = (product: string): BrandConfig => {
	const normalizedProduct = product.toLowerCase() as ProductType;
	
	// Default to arc if product is not found
	if (!brandConfig[normalizedProduct]) {
		return brandConfig.arc;
	}
	
	return brandConfig[normalizedProduct];
};

